import cx from 'classnames'
import type { ComponentProps } from 'react'
// oxlint-disable-next-line no-restricted-imports -- kept to not break too many things in the config portal
import { Link } from 'react-router'

import { useTemplateIsLibrary } from '../../hooks/useTemplateIsLibrary'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useOperationsContext } from '../../workspace/operationsContext'

type Props = {
  templateId: string
} & Partial<ComponentProps<typeof Link>>

export const TemplateParentLink = ({
  templateId,
  className,
  ...props
}: Props) => {
  const { server, branch } = useNavigationParams()
  const { workspaceKey } = useOperationsContext()
  const templateIsLibrary = useTemplateIsLibrary()
  const { applicationTemplates: applicationTemplateOperations } =
    useApplicationViewOperationsContext()
  const templateOperation = applicationTemplateOperations
    .get(templateId)
    ?.operations.at(0)

  const templateLayer = templateOperation?.layer
  const block = templateOperation?.block
  const commonStyles = cx(
    'overflow-hidden text-ellipsis rounded-md bg-inheritance p-2 text-amaze-inkBright',
  )

  return templateOperation && templateLayer && block ? (
    <Link
      {...props}
      to={configurationItem({
        workspaceName: workspaceKey?.name,
        layer: templateLayer,
        block,
        server,
        itemId: templateId,
        branch,
        type: templateIsLibrary(templateId) ? 'library' : 'template',
      })}
      className={cx(commonStyles, 'hover:opacity-90', className)}
    >
      {templateId}
    </Link>
  ) : (
    <span className={cx(commonStyles, 'opacity-30', className)}>
      {templateId}
    </span>
  )
}
